export default __webpack_public_path__ + "static/media/Portal_Savings.b8ebabce.svg";